import UserSearchTable from './UserSearchTable'

export default UserSearchTable
